import { render } from "./PokemonPage.vue?vue&type=template&id=658b00e7"
import script from "./PokemonPage.vue?vue&type=script&lang=js"
export * from "./PokemonPage.vue?vue&type=script&lang=js"
script.render = render

export default script